<template>
    <section id="home" class="section welcome-area bg-overlay overflow-hidden d-flex align-items-center">
        <div class="container">
            <div class="row align-items-center">
                <!-- Welcome Intro Start -->
                <div class="col-12 col-md-6">
                    <div class="welcome-intro">
                        <h1 class="text-white text-center text-md-left">Marketing <br> <span class="fw-4">strategy</span></h1>
                        <p class="text-white text-center text-md-left my-4">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Impedit nihil tenetur minus quidem est deserunt molestias accusamus harum ullam tempore debitis et, expedita, repellat delectus aspernatur neque itaque qui quod.</p>
                        <!-- Buttons -->
                        <div class="button-group d-flex align-items-center justify-content-center justify-content-md-start">
                            <a href="#" class="btn btn-bordered-white">Start a Project</a>
                            <!-- Play Button -->
                            <a class="play-btn" data-fancybox data-width="640" data-height="360" data-small-btn="true" href="https://youtu.be/TKnufs85hXk">
                                <div class="btn-circle play-animation"></div>
                                <div class="btn-circle play-animation animation-short"></div>
                                <!-- Play Icon -->
                                <div class="play-icon">
                                    <i class="fas fa-play"></i>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <!-- Welcome Thumb -->
                    <div class="welcome-thumb-wrapper pt-3 pt-md-5 mt-5">
                        <span class="welcome-thumb-1">
                            <img class="welcome-animation d-block ml-auto" src="assets/img/welcome_thumb_7.png" alt="">
                        </span>
                        <span class="welcome-thumb-2">
                            <img class="welcome-animation d-block" src="assets/img/welcome_thumb_8.png" alt="">
                        </span>
                        <span class="welcome-thumb-3">
                            <img class="welcome-animation d-block" src="assets/img/welcome_thumb_9.png" alt="">
                        </span>
                        <span class="welcome-thumb-4">
                            <img class="welcome-animation d-block" src="assets/img/welcome_thumb_10.png" alt="">
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <!-- Shape Bottom -->
        <div class="welcome-shape">
            <img src="assets/img/hero_shape.png" alt="">
        </div>
    </section>
</template>

<script>
export default {

}
</script>

<style>

</style>